import { Arbitrum, Rumble, Telegram, X, YouTube } from "@/icons";
import type { Chain, SocialMedium } from "@/types";

export const CHAINS: Chain[] = [
  /*
  {
    Icon: ETH,
    id: BigInt(1),
    title: "ETH",
    token: "ETH",
    url: "wss://ethereum-rpc.publicnode.com",
  },
  {
    Icon: BNB,
    id: BigInt(56),
    title: "BNB",
    token: "BNB",
    url: "wss://bsc-rpc.publicnode.com",
  },
  */
  {
    addresses: {
      pid: "0x9f5f98657e714cfbb5af899b722685e8e7f71b7d",
      treasuryPool: "0x9bc6adf2569954a81f9eb8f99a14699fd11284e3",
      xsd: "0xa3034ef5f9d98f4dac6fc44421642c2616d9e346",
    },
    Icon: Arbitrum,
    id: BigInt(42161),
    title: "Arbitrum",
    token: "ETH",
    url: "wss://arbitrum-one-rpc.publicnode.com",
  },
  /*
  {
    Icon: Polygon,
    id: BigInt(137),
    title: "Polygon",
    token: "POL",
    url: "wss://polygon-bor-rpc.publicnode.com",
  },
  {
    Icon: Optimism,
    id: BigInt(10),
    title: "Optimism",
    token: "ETH",
    url: "wss://optimism-rpc.publicnode.com",
  },
  {
    Icon: BASE,
    id: BigInt(8453),
    title: "BASE",
    token: "ETH",
    url: "wss://base-rpc.publicnode.com",
  },
  {
    Icon: Avalanche,
    id: BigInt(43114),
    title: "Avalanche",
    token: "AVAX",
    url: "wss://avalanche-c-chain-rpc.publicnode.com",
  },
  {
    Icon: Pulsechain,
    id: BigInt(369),
    title: "Pulsechain",
    token: "PLS",
    url: "wss://rpc.pulsechain.com",
  },
  */
];

export const GRAMS_PER_TROY_OUNCE = 31.1035;

export const LOCALE = "en-US";

export const SOCIAL_MEDIA: SocialMedium[] = [
  {
    Icon: Telegram,
    title: "Telegram",
    url: "https://t.me/BankXio",
  },
  {
    Icon: YouTube,
    title: "YouTube",
    url: "https://www.youtube.com/@BankXio?sub_confirmation=1",
  },
  {
    Icon: X,
    title: "X",
    url: "https://x.com/bankxio",
  },
  {
    Icon: Rumble,
    title: "Rumble",
    url: "https://rumble.com/c/BankXio",
  },
];

export const UNDEFINED_VALUE = "-";
